"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _SearchFilters = require("../../../types/SearchFilters");

var rulesBuilder = function rulesBuilder(_a) {
  var rules = _a.rules;

  if (!rules || rules && rules.length === 0) {
    return '';
  }

  var query = [];

  if (rules.includes(_SearchFilters.RulesValue.SMOKING)) {
    query.push("(" + [_SearchFilters.Options.YES, _SearchFilters.Options.DISCUSSABLE, _SearchFilters.Options.OUTSIDE].map(function (i) {
      return "facility_smoking_allowed:" + i;
    }).join(' OR ') + ")");
  }

  if (rules.includes(_SearchFilters.RulesValue.PETS)) {
    query.push("(" + [_SearchFilters.Options.YES, _SearchFilters.Options.DISCUSSABLE].map(function (i) {
      return "facility_animal_allowed:" + i;
    }).join(' OR ') + ")");
  }

  if (rules.includes(_SearchFilters.RulesValue.INSTRUMENT)) {
    query.push("(" + [_SearchFilters.Options.YES, _SearchFilters.Options.DISCUSSABLE].map(function (i) {
      return "facility_play_music:" + i;
    }).join(' OR ') + ")");
  }

  return query.join(' AND ');
};

var _default = rulesBuilder;
exports["default"] = _default;